export default __webpack_public_path__ + "static/media/exterior_design.e1835df0.jpeg";